import React from 'react';
import API from '@API/index';
import { useDispatch, useSelector } from 'react-redux';
import { useSnackbar } from 'notistack';
import Utils from '@utils/index';
import { setDevices } from '@store/assets/actions';
import { IStoreState } from '@store/index';
import { flatten } from 'lodash';

function useUpdateEdgeDevices(
  companyId?: string,
  deps?: React.DependencyList
) {
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();

  const companies = useSelector((store: IStoreState) => store.companies.companies);

  const [loading, setLoading] = React.useState<boolean>(true);

  const companiesRef = React.useRef(companies)

  React.useEffect(() => { companiesRef.current = companies }, [companies]);

  const perform = React.useCallback(() => {
    if (companyId) {
      setLoading(true);
      API.EdgeDevices.listDevices('All', undefined, companyId)
        .then((devices) => {
          dispatch(setDevices(devices))
        })
        .catch((error) => {
          enqueueSnackbar(Utils.Error.getErrorMessage(error), { variant: 'error' })
        })
        .finally(() => {
          setLoading(false);
        })
    } else {
      setLoading(true);
      Promise.all(companiesRef.current.map((el) => API.EdgeDevices.listDevices('All', undefined, el.companyId)))
        .then((devices) => {
          dispatch(setDevices(flatten(devices)))
        })
        .catch((error) => {
          enqueueSnackbar(Utils.Error.getErrorMessage(error), { variant: 'error' })
        })
        .finally(() => {
          setLoading(false);
        })
    }
  }, [dispatch, companyId, enqueueSnackbar])

  React.useEffect(perform, [...(deps || []), companyId, perform])
  return loading;
}

export default useUpdateEdgeDevices;
